module.exports = __webpack_public_path__ + "img/wps_load_item.ab92cf5b.svg";